var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { USER_INFO_INFO_REQUEST, USER_INFO_INFO_SUCCESS } from '../actions/getUserFP';
var initialState = {
    isFetching: false,
    info: {}
};
export function userInfoFPReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case USER_INFO_INFO_REQUEST:
            return __assign(__assign({}, state), { isFetching: true });
        case USER_INFO_INFO_SUCCESS:
            return __assign(__assign({}, state), { isFetching: false, info: action.payload });
        default:
            return state;
    }
}
;
//# sourceMappingURL=getUserFP.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { USER_INFO_INFO_REQUEST, USER_INFO_INFO_SUCCESS } from '../actions/getUserFP';
var initialState = {
    isFetching: false,
    info: {}
};
export function userInfoFPReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case USER_INFO_INFO_REQUEST:
            return __assign(__assign({}, state), { isFetching: true });
        case USER_INFO_INFO_SUCCESS:
            return __assign(__assign({}, state), { isFetching: false, info: action.payload });
        default:
            return state;
    }
}
;
//# sourceMappingURL=getUserFP.js.map